export default __webpack_public_path__ + "static/media/ic-external-link.b3ae02e2.svg";